<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { reactive, defineEmits, ref } from 'vue';

import CardComponent from '@/components/ui/CardComponent.vue';

import type { AssetDetailResponse } from "@/types/services/mandate/tradingMandate.type.ts";

const { t } = useI18n();

const emits = defineEmits(['closeModal']);

const parentProps = defineProps<{
  availableAssets: AssetDetailResponse[],
}>();

const formValid = ref<boolean>(false);

const form = reactive({
  name: '',
});
</script>

<template>
  <v-form class="w-100 d-flex align-center">
    <CardComponent with-actions>
      <template #title>
        {{ t('components.selectAssetComponent.title') }}
      </template>
      <template #item>
        <v-form v-model="formValid" class="my-4">
          <v-row align="start">
            <v-col cols="12">
              <v-select
                v-model="form.name"
                :item-title="() => ''"
                :items="parentProps.availableAssets"
                item-value="name"
              >
                <template #item="{ props, item }">
                  <v-list-item v-bind="props">
                    <div class="d-flex justify-space-between w-100">
                      <span>{{ item.raw.name }}</span>
                      <span class="text-grey-darken-1 text-caption">{{ item.raw.amount }} €</span>
                    </div>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <span>{{ item.raw.name }}</span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template #actions>
        <div class="d-flex flex-row justify-space-between ga-4 mt-2">
          <v-btn
            :text="t('common.buttons.cancel')"
            variant="outlined"
            @click.prevent="emits('closeModal', false)"
          />
          <v-btn
            :disabled="!formValid"
            :text="t('common.buttons.validate')"
            color="primary"
            type="submit"
            variant="flat"
            @click="emits('closeModal', form)"
          />
        </div>
      </template>
    </CardComponent>
  </v-form>
</template>
